var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 10a2 2 0 0 1-2-2.002v-.14c0-1.43 2.857-1.43 3.571-2.144.715-.714.358-1.428 0-2.143C3.571 3.571 2.233 0 5 0s1.429 3.571 1.429 3.571c-.358.715-.715 1.429 0 2.143C6.96 6.247 10 6.43 10 7.857v.14A1.996 1.996 0 0 1 8 10z"
})));
export default SvgPersonSm;